module.exports = __webpack_public_path__ + "img/Infrastructure_Icon.5f3253d9.png";